export function isAdult(dateOfBirth: { day: number; month: number; year: number }) {
  return new Date(Number(dateOfBirth.year) + 18, dateOfBirth.month, dateOfBirth.day) <= new Date();
}
